import { render, staticRenderFns } from "./editCliente.vue?vue&type=template&id=3f436a7e&"
import script from "./editCliente.vue?vue&type=script&lang=js&"
export * from "./editCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSeparator,QInput,QSelect,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSeparator,QInput,QSelect,QBtn})
